'use client';

import { useState, useEffect } from "react";
function useIsStuck(elementRef, isSticky = true) {
  const [isStuck, setIsStuck] = useState(false);
  useEffect(() => {
    if (isSticky && window) {
      window.addEventListener("scroll", handleSticky, { passive: true });
    }
    return () => {
      if (isSticky && window) {
        window.removeEventListener("scroll", handleSticky);
      }
    };
  }, [isSticky, isStuck]);
  const handleSticky = () => {
    var _a;
    const elementPosition = ((_a = elementRef.current) == null ? void 0 : _a.offsetTop) || 0;
    setIsStuck(elementPosition > 0);
  };
  return isStuck;
}
export {
  useIsStuck
};
